<form action="">
  <mat-form-field id="targetBlue" class="mt-4" appearance="fill">
    <mat-label>Add Tracking Information</mat-label>
    <mat-select [(value)]="trackingInfo">
      <mat-option value="Freight">Freight</mat-option>
      <mat-option value="Parcel">Parcel</mat-option>
      <mat-option value="Drop-off">Drop-off</mat-option>
    </mat-select>
  </mat-form-field>
  <div *ngIf="trackingInfo">
    <div *ngIf="trackingInfo == 'Freight'">
      <div class="d-flex mt-2">
        <mat-form-field class="example-full-width mr-4">
          <mat-label>Freight Carrier</mat-label>

          <input
            type="text"
            name="Freight"
            [(ngModel)]="freightCarrier"
            placeholder="Freight Carrier"
            aria-label="Freight Carrier"
            matInput
          />
        </mat-form-field>
        <mat-form-field class="example-full-width">
          <mat-label>PRO Number</mat-label>

          <input
            type="number"
            name="proNumber"
            [(ngModel)]="proNumber"
            placeholder="PRO Number"
            aria-label="PRO Number"
            matInput
          />
        </mat-form-field>
      </div>
    </div>
    <div *ngIf="trackingInfo == 'Parcel'">
      <div class="d-flex mt-2">
        <mat-form-field class="example-full-width mr-4">
          <mat-label>Small Parcel Carrier</mat-label>

          <input
            type="text"
            id="smallParcelCarrier"
            name="smallParcelCarrier"
            [(ngModel)]="smallParcelCarrier"
            placeholder="Small Parcel Carrier"
            aria-label="Small Parcel Carrier"
            matInput
          />
        </mat-form-field>
        <mat-form-field class="example-full-width">
          <mat-label>Tracking Number</mat-label>

          <input
            type="text"
            id="trackingNumber"
            name="trackingNumber"
            [(ngModel)]="trackingNumber"
            [disabled]="showTraking"
            aria-label="Tracking Number"
            placeholder="Tracking Number"
            matInput
          />
        </mat-form-field>
      </div>
    </div>
    <div class="form-group w-25">
      <div class="d-flex align-items-center">
        <label for="expectedDate">Expected Date: </label>
        <div class="d-flex align-items-center">
          <span *ngIf="editTracking" class="ml-2"> {{ expectedDateOld }}</span>
          <!-- <button
            class="ml-2 btn btn-link btn-info btn-just-icon"
            (click)="editDate = !editDate"
          >
            <i class="material-icons">mode_edit</i>
          </button> -->
        </div>
      </div>
      <input
        type="date"
        class="form-control"
        name="expected"
        #expected="ngModel"
        [(ngModel)]="expectedDate"
        [disabled]="showTraking || disabled"
        matInput
      />
    </div>
    <div
      *ngIf="!editTracking"
      class="d-flex align-items-end justify-content-end"
    >
      <button
        (click)="addTracking()"
        class="btn btn-info align-self-end"
        [disabled]="saving"
      >
        + Add Tracking
      </button>
    </div>
    <div
      *ngIf="editTracking"
      class="d-flex align-items-end justify-content-end"
    >
      <button
        (click)="initTrackingData()"
        class="btn btn-danger mr-2 align-self-end"
      >
        Cancel
      </button>
      <button (click)="updateTracking()" class="btn btn-info align-self-end">
        Update Tracking Information
      </button>
    </div>
  </div>
</form>

<app-loading *ngIf="!tableTrakings"></app-loading>

<div *ngIf="tableTrakings.length > 0" class="w-100">
  <h4>Transportation Details List</h4>
  <app-table-traking
    [elements]="tableTrakings"
    (out)="actions($event)"
  ></app-table-traking>
</div>
<!-- <div *ngIf="pickups">
  <h4>Pickup</h4>
  <form  *ngFor="let pickup of pickups" class="grid-container mt-4" action="">
    <div class="">
      <label for="initialDate">Promise Date: </label>
      <p>{{(pickup.initialDate != null ? pickup.initialDate.timestamp * 1000 : null) | date: 'MM/dd/yyyy' }}</p>
    </div>
    <div class="">
      <label for="expectedDate">Expected Date: </label>
      <p>{{(pickup.expectedDate != null ? pickup.expectedDate.timestamp * 1000 : null) | date: 'MM/dd/yyyy' }}</p>
    </div>
    <mat-form-field class="example-full-width has-label">
      <input
      class=""
       
        id="GTS Truck"
        name="GTS Truck"
        [(ngModel)]="pickup.truck.name"
        aria-label="GTS Truck"
        placeholder="GTS Truck"
        matInput
        disabled
      />
    </mat-form-field>
    <mat-form-field class="example-full-width has-label">
      <input
      type="text"
      id="GTS Driver"
      name="GTS Driver"
      [(ngModel)]="pickup.driver.name"
      aria-label="GTS Driver"
      placeholder="GTS Driver"
      matInput
      disabled
      />
    </mat-form-field>
    <mat-form-field class="example-full-width has-label">
      <input
      type="text"
      id="type"
      name="type"
      [(ngModel)]="pickup.type"
      aria-label="type"
      placeholder="Type"
      matInput
      disabled
      />
    </mat-form-field>
  </form>
</div> -->
<div
  data-backdrop="static"
  class="modal modal-delete"
  tabindex="-1"
  role="dialog"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">
          Are you sure you want to delete this tracking?
        </h3>
        <button
          type="button"
          class="close"
          (click)="closeDeleteModal()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="close"
          (click)="closeDeleteModal()"
          class="btn btn-secondary"
        >
          Close
        </button>
        <button type="button" class="btn btn-danger" (click)="deleteTraking()">
          Delete
        </button>
      </div>
    </div>
  </div>
</div>
